export const defaultEdgeProps = [
  {
    key: "pressure_pipe",
    label: "Pressure pipe",
    type: "checkbox",
    unit: "-",
    value: false,
  },
];